export class BuscarEnvolvidos{

  codigoDiretoria?:number ;
  codigoEscola?:number;
  codigoTurma?:number ;
  codigoTurno?:number;
  anoAtual:number;
  nome?:string;
  ra?:string ;

}
